// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2651":"css/app.6839","9460":"css/admin-app.6839"}[chunkId] + ".css";
};